// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Renderer__JsonAccessor from "./Renderer__JsonAccessor.bs.js";

function makeEmpty() {
  return null;
}

function extractValue(json, path) {
  return Renderer__JsonAccessor.extractValue(json, path);
}

function toJson(prim) {
  return prim;
}

function fromJson(prim) {
  return prim;
}

var Schema;

export {
  toJson ,
  fromJson ,
  makeEmpty ,
  Schema ,
  extractValue ,
}
/* No side effect */
